"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _i18n = require("@wordpress/i18n");

/**
 * WordPress dependencies
 */
const variations = [{
  name: 'default',
  isDefault: true,
  attributes: {
    buttonText: (0, _i18n.__)('Search'),
    label: (0, _i18n.__)('Search')
  }
}];
var _default = variations;
exports.default = _default;
//# sourceMappingURL=variations.js.map